import { Box, Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";

export type idListType = {
  idList: string[];
  setIdList?: (idList: string[]) => void;
};

export const IdDisplayBox = ({ idListMap }: { idListMap: idListType }) => {
  return (
    <Box mt={2}>
      {idListMap.idList.map((id, index) => (
        <Tag
          key={index}
          size={"md"}
          variant={"solid"}
          backgroundColor={"blueInputHover"}
          _hover={{ backgroundColor: "primary.light" }}
          color={"text.dark"}
          borderRadius={14}
          m={1}
          py={1}
          px={2}
        >
          <TagLabel>{id}</TagLabel>
          {idListMap.setIdList && (
            <TagCloseButton
              onClick={() => {
                const indexToRemove = idListMap.idList.indexOf(id);
                if (indexToRemove > -1 && idListMap.setIdList) {
                  idListMap.idList.splice(indexToRemove, 1);
                  idListMap.setIdList([...idListMap.idList]);
                }
              }}
            />
          )}
        </Tag>
      ))}
    </Box>
  );
};
